<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<p class="dedicationText">For making a stranger feel a little less alien in a strange land, <em class="italic">The Covenant Rising</em> is dedicated to the Brum Balti Boyz – Mike Chinn, Peter Coleborn, John Howard, Joel Lane, David Sutton; and to the Gurlz – Jan Edwards, Sue Edwards, Sandra Sutton. And, of course, to my wife, Anne.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?169c1eb8